import { LicenseInfo } from '@mui/x-license';

const MUI_PRO_LICENSE =
  '57912251b83b8230d1489841df5a04b9Tz05OTA3OSxFPTE3NTkzMzE3NTMwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPWluaXRpYWwsS1Y9Mg==';

export const muiProLicenseInit = () => {
  return LicenseInfo.setLicenseKey(MUI_PRO_LICENSE);
};
